module.exports = __webpack_public_path__ + "static/img/linkaja.f496792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/payment/linkaja.png
// module id = 4CEe
// module chunks = 1